/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whereisyourbusinesslocated4Inputs */

const en_whereisyourbusinesslocated4 = /** @type {(inputs: Whereisyourbusinesslocated4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where is your business located?`)
};

const de_whereisyourbusinesslocated4 = /** @type {(inputs: Whereisyourbusinesslocated4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wo ist dein Unternehmen?`)
};

/**
* | output |
* | --- |
* | "Where is your business located?" |
*
* @param {Whereisyourbusinesslocated4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const whereisyourbusinesslocated4 = /** @type {((inputs?: Whereisyourbusinesslocated4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whereisyourbusinesslocated4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_whereisyourbusinesslocated4(inputs)
	return de_whereisyourbusinesslocated4(inputs)
});
export { whereisyourbusinesslocated4 as "whereIsYourBusinessLocated" }